<template>
    <div v-if="active" id="map" class="go-map w-100 rounded cursor-pointer"
        style="text-align: initial; line-height:100%; width: 100%; height: 100%;"></div>
</template>

<script>

const fn = window.__pt.fn;
const config = window.__pt.settings.site;

const styleArray = [
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

export default {

    props: {
        places: Array,
        dispatch: Object,
        selected: Object,
        active: Boolean
    },
    watch: {
        selected: function () {
            if (!('google' in window && google.maps)) {
              return;
            }

            if (this.selected !== null) {
                this.markPlace();
            } else {
                let urlSplit = window.location.href.split("/");
                let pt = new google.maps.LatLng(this.initLat, this.initLng);
                this.map.setCenter(pt);
                this.map.setZoom(5);

                if (urlSplit.length > 4) {
                    if (urlSplit[5] != "") {
                        this.setStateZone();
                    }
                }
            }
        },
        places: function () {
            if ('google' in window && google.maps) {
                /* this.handleMap();
                this.map.setZoom(8); */
                this.setStateZone();
            }

        },
        active: function () {
            this.initializeMap();
        }
    },
    data() {
        return {
            name: "Nombre",
            map: null,
            totalItems: 0,
            initLat: config.code.toLowerCase() =="ptmx" ? 21.782979 : 6.2875386,
            initLng: config.code.toLowerCase() =="ptmx" ? -100.912983 : -82.3783195
        };
    },
    mounted() {
        if (!this.active) {
            return;
        }

        this.initializeMap();
    },
    methods: {
        initializeMap() {
            this.totalItems = this.places.length;
            if ('google' in window && google.maps) {
                this.handleMap();
            } else {
                fn.getScript(config.endPoints.googleMapsApi, "", this.handleMap);
            }
        },
        firstCoords() {
            for (let i = 0; i < this.places.length; i++) {
                let place = this.places[i];
                if (place.latitude != "") {
                    return { lat: +place.latitude, lng: +place.longitude };
                }
            }

            return { lat: this.initLat, lng: this.initLng };
        },
        handleMap() {
            let initialCoords = this.dispatch.path ? this.firstCoords() : { lat: this.initLat, lng: this.initLng };
            let zoom = 5;

            if (this.dispatch.path) {
                zoom = 8;
            }

            if (this.dispatch.path && this.places.length === 1) {
                zoom = 15;
            }

            if (window.screen.width <= 576) {
                zoom = 15;
                initialCoords = this.firstCoords();
            }

            this.map = new google.maps.Map(document.getElementById("map"), {
                center: initialCoords,
                scrollwheel: false,
                zoom: zoom,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            this.map.setOptions({ styles: styleArray });
            var _context = this;
            if (this.places) {
                this.places.forEach(element => {

                    if (element.latitude != "" && element.longitude != "") {
                        element.marker = new google.maps.Marker({
                            position: { lat: +element.latitude, lng: +element.longitude },
                            draggable: false,
                            map: this.map,
                            icon: '/assets/img/icon_ui/MarkerPt.svg',
                            title: element.displayNameShort,
                            animation: google.maps.Animation.DROP
                        });

                        let content = this.infoContent(element);

                        element.infoWindow = new google.maps.InfoWindow({
                            content: content
                        });

                        google.maps.event.addListener(element.marker, 'mousedown', function () {
                            _context.$emit('selectMarker', element);
                        });

                        google.maps.event.addListener(element.marker, 'mouseover', function () {
                            element.marker.setIcon('/assets/img/icon_ui/MarkerPtHover.svg');
                        });

                        google.maps.event.addListener(element.marker, 'mouseout', function () {
                            element.marker.setIcon('/assets/img/icon_ui/MarkerPt.svg');
                        });
                    }

                });

                if (window.screen.width <= 576) {
                    this.map.setZoom(15);
                }
            }
        },
        infoContent(info) {
            return `
            <div class="pts-bubble"><div class="pts-bubble-content"><h2>${info.displayNameShort}</h2><p class="note">${info.stateName}</p><p class="address">${info.address} C.P. ${info.postalCode}</p><p>${info.businessHours}<p><a href="/puntos-de-atencion/la-gran-plaza">mas información</a></p></div></div>
            `;
        },
        markPlace() {
            let initialCoords = { lat: +this.selected.latitude, lng: +this.selected.longitude };
            var pt = new google.maps.LatLng(initialCoords.lat, initialCoords.lng);
            this.map.setCenter(pt);
            this.map.setZoom(15);
        },
        setStateZone() {

            let coords = this.firstCoords();
            var pt = new google.maps.LatLng(coords.lat, coords.lng);
            this.map.setCenter(pt);
            this.map.setZoom(this.totalItems === this.places.length ? 5 : 8);

            if (window.screen.width <= 576) {
                this.map.setZoom(15);
            }
        }
    }
};
</script>